import { createEditor } from 'lexical';
import { exportEditorStateToDraft } from './exportEditorStateToDraft';
import { LinkPreviewNode } from '../../nodes/LinkPreviewNode';

export function exportLexicalJsonToDraft(serialized: string, id: string) {
  const editor = createEditor({
    namespace: 'ExportOnly',
    onError: console.error,
    nodes: [LinkPreviewNode],
  });
  let draft;
  editor.setEditorState(editor.parseEditorState(JSON.parse(serialized)));
  const state = editor.getEditorState();
  draft = exportEditorStateToDraft(state, id);
  return draft;
}


